import { PdRatingItem } from "./PdRatingItem.js";
//#region src/pd-rating/pd-rating-item.ts
var tag = "pd-rating-item";
if (!customElements.get(tag)) customElements.define(tag, PdRatingItem);
//#endregion
export { PdRatingItem };
